import { GlTooltipDirective, GlButton } from '@gitlab/ui';
import { s__ } from '~/locale';
export default {
    i18n: {
        buttonLabel: s__('MergeRequests|Create issue to resolve thread')
    },
    name: 'ResolveWithIssueButton',
    components: {
        GlButton
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        url: {
            type: String,
            required: true
        }
    }
};
